import { Component } from '@angular/core';
import { IonicPage, ModalController, Platform } from 'ionic-angular';
import { NavigationService } from '../../../../providers/navigation/navigation';
@IonicPage()
@Component({
    selector: 'page-tabs-sf7',
    templateUrl: 'tabs-sf7.html',
})
export class TabsSf7Page {
    public activeTab = 'HomePage';
    constructor(
        private navigationService: NavigationService,
        public modalCtrl: ModalController,
        public platform: Platform,
        // private viewCtrl: ViewController,
    ) {
      console.log(this.platform, 'platformplatformplatform');
    }

    initHomeMobile() {
        this.navigationService.setRoot(this.activeTab);
    }
      
    toProfile() {
      console.log('toProfile');
    }
  
    search() {
      const modal = this.modalCtrl.create('EmpListPage', { popBack: {} }, { cssClass: "" });
      modal.present();
    }
  
    openfeature() {
      const modal = this.modalCtrl.create('FeaturesSf7Page', {}, { cssClass: "" });
      modal.present();
    }
  
    moveTab(route) {
      console.log('moveTab1', route);
      this.activeTab = route;
      this.navigationService.setRoot(this.activeTab, { fromTabs: true });
    }
}



// WEBPACK FOOTER //
// ./src/pages/sf7/components/tabs-sf7/tabs-sf7.ts